import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { memo } from "react";
import { getLinkPreviewImage } from "@shared/blocks/helpers";
import { cloudDocumentProviderLabel } from "./host-urls";
import { resolveCloudDocumentDisplayTitle } from "./resolve-title";
import "./view.scss";
function faviconUrlForProvider(provider) {
    if (provider === "notion") {
        return "https://www.google.com/s2/favicons?domain=notion.so&sz=32";
    }
    if (provider === "docs") {
        return "https://www.google.com/s2/favicons?domain=docs.google.com&sz=32";
    }
    return undefined;
}
function ProviderLogo({ provider }) {
    const faviconUrl = faviconUrlForProvider(provider);
    if (!faviconUrl)
        return undefined;
    return (_jsx("span", { className: "cloud-document-link-content__provider-logo", "aria-hidden": "true", children: _jsx("img", { className: "cloud-document-link-content__provider-logo-image", src: faviconUrl, alt: "", width: 16, height: 16 }) }));
}
export const CloudDocumentLinkBlockView = memo(({ block }) => {
    const content = block.content;
    const url = content.url;
    // TODO: Handle private / auth-only Notion & Google Docs (ingest often gets no thumbnail or blocked HTML; may need OAuth, service accounts, or client-side capture — treat separately from public OG previews).
    const previewUrl = getLinkPreviewImage(block);
    const providerLabel = cloudDocumentProviderLabel(url);
    const title = resolveCloudDocumentDisplayTitle(block, content, url);
    const body = (_jsxs(_Fragment, { children: [_jsxs("div", { className: "cloud-document-link-content__header", children: [_jsx("div", { className: "cloud-document-link-content__logo-row", children: _jsx(ProviderLogo, { provider: providerLabel }) }), _jsx("div", { className: "cloud-document-link-content__provider", children: providerLabel }), _jsx("div", { className: "cloud-document-link-content__title", children: title })] }), _jsx("div", { className: "cloud-document-link-content__preview", children: previewUrl ? (_jsx("img", { className: "cloud-document-link-content__snapshot", src: previewUrl, alt: title })) : (_jsx("div", { className: "cloud-document-link-content__placeholder", "aria-hidden": "true" })) })] }));
    return (_jsx("div", { className: "cloud-document-link-content", "aria-label": url ? title : undefined, children: body }));
});
